export default async function MovePlanToParentApi(planId, parentPlanId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ parentPlanId }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/hierarchy/parent`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: "Failed to move plan to parent" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Failed to move plan to parent" };
  }

  return res;
} 